import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { FileSpreadsheet } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { SalesPeriodFilter } from "@/components/SalesPeriodFilter";

export default function SalesExportDialog({ open, onOpenChange, period, onApply }) {
  const [local, setLocal] = useState(period);
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (open) setLocal(period); }, [open, period]);

  async function doExport() {
    if (local.from && local.to && local.from > local.to) {
      toast.error("Data de început e după data de sfârșit");
      return;
    }
    setBusy(true);
    try {
      const params = {};
      if (local.from) params.date_from = local.from;
      if (local.to) params.date_to = local.to;
      const res = await api.get("/sales/export.xlsx", { params, responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `vanzari-${local.from || "inceput"}_${local.to || "azi"}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      onApply(local);
      onOpenChange(false);
      toast.success("Export descărcat");
    } catch {
      toast.error("Exportul a eșuat");
    } finally {
      setBusy(false);
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="sales-export-dialog">
        <DialogHeader>
          <DialogTitle>Export Excel vânzări</DialogTitle>
          <DialogDescription>Alege perioada pentru care descarci vânzările.</DialogDescription>
        </DialogHeader>
        <SalesPeriodFilter period={local} onChange={setLocal} prefix="export-period" />
        <button
          onClick={doExport}
          disabled={busy}
          data-testid="sales-export-confirm-btn"
          className="mt-2 inline-flex items-center justify-center gap-1.5 text-sm font-medium px-4 py-2 rounded-full bg-emerald-600 text-white hover:bg-emerald-700 transition-colors disabled:opacity-60"
        >
          <FileSpreadsheet className="w-4 h-4" /> {busy ? "Se generează…" : "Descarcă Excel"}
        </button>
      </DialogContent>
    </Dialog>
  );
}
